import ItemDocumento from "./ItemDocumento";
import ItemRegistroTiempo from "./ItemRegistroTiempo";
import ItemTarea from "./ItemTarea";

export default class ItemOrdenDeTrabajo {
    Id: number;
    Serie: string;
    ODT: number;
    NumeroDocumento: string;
    CodigoCliente: string;
    De: string;
    Para: string;
    Usuario: string;
    FechaEnvio: string;
    FechaEntrega: string;
    FechaFinalizacion: string;
    Descripcion: string;
    Nombre: string;
    Nombre2: string;
    Direccion: string;
    Direccion2: string;
    CPostal: string;
    Pais: string;
    Provincia: string;
    Poblacion: string;
    PosicionGPS: string;
    Formulario: string;
    Observaciones: string;
    Estado: number;
    FechaAlta: string;
    ExtraHTML: string;
    EnvioDirecto: number;
    Piezas: number;
    Division: string;
    KilosCaja: number;
    Icono: string;
    Tareas: string;
    CodCliente: number;
    CodDireccion: number;
    ListaTareas: ItemTarea[];
    Filtros: string;
    UsuarioSolicitaAsistencia: string;
    CorreoUsuarioSolicitaAsistencia: string;
    TelefonoEmpresa: string;
    Telefono: string;
    Email: string;
    Web: string;
    IdExterno: string;
    Asunto: string;
    ListaPartesTrabajo: ItemRegistroTiempo[];
    ListaDocumentos: ItemDocumento[];
    FechaEnvioOrden: string;
    FechaOrden: string;
    IconoEstado: string;
    Cerrado: boolean;
    Firmas: number;
    Adjuntos: number;

    constructor() {
        this.Id = 0;
        this.Serie = "";
        this.ODT = 0;
        this.NumeroDocumento = "";
        this.CodigoCliente = "";
        this.De = "";
        this.Para = "";
        this.Usuario = "";
        this.FechaEnvio = "";
        this.FechaEntrega = "";
        this.FechaFinalizacion = "";
        this.Descripcion = "";
        this.Nombre = "";
        this.Nombre2 = "";
        this.Direccion = "";
        this.Direccion2 = "";
        this.CPostal = "";
        this.Pais = "";
        this.Provincia = "";
        this.Poblacion = "";
        this.PosicionGPS = "";
        this.Formulario = "";
        this.Observaciones = "";
        this.Estado = 0;
        this.FechaAlta = "";
        this.ExtraHTML = "";
        this.EnvioDirecto = 0;
        this.Piezas = 0;
        this.Division = "";
        this.KilosCaja = 0;
        this.Icono = "";
        this.Tareas = "";
        this.CodCliente = 0;
        this.CodDireccion = 0;
        this.ListaTareas = [];
        this.Filtros = "";
        this.UsuarioSolicitaAsistencia = "";
        this.CorreoUsuarioSolicitaAsistencia = "";
        this.TelefonoEmpresa = "";
        this.Telefono = "";
        this.Email = "";
        this.Web = "";
        this.IdExterno = "";
        this.Asunto = "";
        this.ListaPartesTrabajo = [];
        this.ListaDocumentos = [];
        this.FechaEnvioOrden = "";
        this.FechaOrden = "";
        this.IconoEstado = "";
        this.Cerrado = false;
        this.Firmas = 0;
        this.Adjuntos = 0;
    };
};
